module.exports = __webpack_public_path__ + "img/pdf.8457949e.svg";